function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_27917_30256)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.67 41.5C14.5257 41.5 16.03 39.9957 16.03 38.14C16.03 36.2844 14.5257 34.78 12.67 34.78C10.8143 34.78 9.31 36.2844 9.31 38.14C9.31 39.9957 10.8143 41.5 12.67 41.5Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.01 41.5C35.8657 41.5 37.37 39.9957 37.37 38.14C37.37 36.2844 35.8657 34.78 34.01 34.78C32.1543 34.78 30.65 36.2844 30.65 38.14C30.65 39.9957 32.1543 41.5 34.01 41.5Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.95 38.14H30.64",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.04 38.14H22.48",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.64 27.01L27.68 26.46C26.57 25.83 25.31 25.49 24.04 25.49H17.94C16.56 25.49 15.19 25.83 13.97 26.49L8.88 29.22L6.55 29.51C5.81 29.6 5.25 30.23 5.25 30.97V32.31C5.25 32.68 5.16 33.05 4.99 33.38L4.76 33.82C4.59 34.16 4.5 34.53 4.5 34.9V35.91C4.5 36.55 4.92 37.11 5.53 37.29L6.87 37.69C7.83 37.98 8.31 38.13 9.31 38.13",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.37 38.14H38.16L41.52 37.28C42.09 37.13 42.49 36.62 42.49 36.02V35.02C42.49 34.78 42.4 34.54 42.23 34.37L41.95 34.08C41.77 33.89 41.67 33.64 41.67 33.38V32.81C41.67 32.29 41.37 31.81 40.9 31.59C39.63 30.99 38.28 30.57 36.89 30.34L33.49 29.79L32.19 29.05",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.26 17.2C24.7397 17.2 26.75 15.1942 26.75 12.72C26.75 10.2458 24.7397 8.23999 22.26 8.23999C19.7802 8.23999 17.77 10.2458 17.77 12.72C17.77 15.1942 19.7802 17.2 22.26 17.2Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.03 12.72H15.05",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.48 12.72H31.5",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.03 12.72H15.05",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.48 12.72H31.5",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.73 6.20001L17.16 7.63001",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.36 17.82L28.79 19.24",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.26 3.5V5.52",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.26 19.93V21.95",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.79 6.20001L27.36 7.63001",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.16 17.82L15.73 19.24",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.49 31.07L29 29.65C28.94 29.47 28.79 29.32 28.61 29.26L27.19 28.77C26.62 28.57 26.62 27.77 27.19 27.57L28.61 27.08C28.79 27.02 28.94 26.87 29 26.69L29.49 25.27C29.69 24.7 30.5 24.7 30.69 25.27L31.18 26.69C31.24 26.87 31.39 27.02 31.57 27.08L32.99 27.57C33.56 27.77 33.56 28.57 32.99 28.77L31.57 29.26C31.39 29.32 31.24 29.47 31.18 29.65L30.69 31.07C30.49 31.64 29.68 31.64 29.49 31.07V31.07Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.15 33.74L14.66 32.32C14.6 32.14 14.45 31.99 14.27 31.93L12.85 31.44C12.28 31.24 12.28 30.44 12.85 30.24L14.27 29.75C14.45 29.69 14.6 29.54 14.66 29.36L15.15 27.94C15.35 27.37 16.16 27.37 16.35 27.94L16.84 29.36C16.9 29.54 17.05 29.69 17.23 29.75L18.65 30.24C19.22 30.44 19.22 31.24 18.65 31.44L17.23 31.93C17.05 31.99 16.9 32.14 16.84 32.32L16.35 33.74C16.15 34.31 15.34 34.31 15.15 33.74V33.74Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.11 39.97L22.1 37.06C22.04 36.88 21.89 36.73 21.71 36.67L18.79 35.66C18.22 35.46 18.22 34.66 18.79 34.46L21.71 33.45C21.89 33.39 22.04 33.24 22.1 33.06L23.11 30.15C23.31 29.58 24.12 29.58 24.31 30.15L25.32 33.06C25.38 33.24 25.53 33.39 25.71 33.45L28.63 34.46C29.2 34.66 29.2 35.46 28.63 35.66L25.71 36.67C25.53 36.73 25.38 36.88 25.32 37.06L24.31 39.97C24.11 40.54 23.3 40.54 23.11 39.97Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_27917_30256"
}, /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 39,
  fill: "white",
  transform: "translate(4 3)"
})));
function SvgGlared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlared);
export default __webpack_public_path__ + "static/media/glared.f825a27c20a2c3dcf76749a64ad781c3.svg";
export { ForwardRef as ReactComponent };